import {
    AutocompleteInput,
    Create,
    NumberInput,
    ReferenceInput,
    SimpleForm,
    TextInput
} from '@/components/admin';
import { Card, CardContent, CardHeader, CardTitle } from '@/components/ui/card';
import { Layers, Package } from 'lucide-react';
import { required } from 'ra-core';
import { AutoReferenceField } from '../documents/shared/AutoReferenceField';
import { BoMItemsTable } from './BoMItemsTable';

export const BoMCreate = () => {
    return (
        <Create>
            <SimpleForm className="w-full space-y-6">
                <Card className="w-full shadow-sm">
                    <CardHeader className="pb-3 border-b bg-muted/50">
                        <div className="flex items-center gap-2">
                            <Layers className="w-5 h-5 text-muted-foreground" />
                            <CardTitle className="text-lg font-semibold tracking-tight">New Bill of Materials</CardTitle>
                        </div>
                    </CardHeader>
                    <CardContent className="pt-6">
                        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6">
                            <AutoReferenceField docType="bom" />

                            <ReferenceInput source="project_id" reference="projects">
                                <AutocompleteInput label="Project" validate={required()} className="w-full" />
                            </ReferenceInput>

                            <ReferenceInput source="design_request_id" reference="design_requests">
                                <AutocompleteInput label="Design Request (Optional)" className="w-full" />
                            </ReferenceInput>

                            <TextInput source="version" label="Version" defaultValue="1.0" validate={required()} className="w-full" />
                        </div>
                    </CardContent>
                </Card>

                <Card className="w-full shadow-sm">
                    <CardHeader className="pb-3 border-b">
                        <div className="flex items-center gap-2">
                            <Package className="w-5 h-5 text-muted-foreground" />
                            <CardTitle className="text-lg font-semibold tracking-tight">Material Breakdown</CardTitle>
                        </div>
                    </CardHeader>
                    <CardContent className="pt-6 space-y-6">
                        <BoMItemsTable />
                        
                        <div className="flex justify-end pt-4 border-t">
                            <div className="bg-muted p-4 rounded-lg border flex items-center gap-4">
                                <span className="text-xs font-bold uppercase tracking-widest text-muted-foreground">Total Estimated Cost (₹)</span>
                                <NumberInput source="total_estimated_cost" label={false} readOnly className="font-bold text-xl text-blue-600" />
                            </div>
                        </div>
                    </CardContent>
                </Card>

                <div className="hidden">
                    <TextInput source="status" defaultValue="draft" />
                </div>
            </SimpleForm>
        </Create>
    );
};
